import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-fed-cases",
  "use": "icon-leo-fed-cases-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-fed-cases\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"320\" cy=\"352\" r=\"96\" /><circle cx=\"704\" cy=\"352\" r=\"96\" /><circle cx=\"512\" cy=\"672\" r=\"96\" /><path d=\"M384 400l96 192M640 400l-96 192\" /><rect x=\"448\" y=\"288\" width=\"128\" height=\"48\" rx=\"8\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-fed-cases.svg
// module id = Lk6f
// module chunks = 478